import { connect } from 'react-redux';
import { ConnectedCasesTileViewProps } from 'app/area/case/components';
import { api } from 'app/area/case/features/search-cases/api';
import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';
import { whenIdle } from 'app/infrastructure/redux/when-idle';
import { debug } from 'app/infrastructure/log';
import { RenderMode } from 'app/types-shared';

export const withSearchCasesToConnect = (component: any, uiEngineProps: any) => {
  const dispatchToProps = (dispatch: any): Partial<ConnectedCasesTileViewProps> => {
    return {
      createSearchForCasesToConnect: async (caseDraftId: number, connectionTypeId: number, renderMode?: RenderMode) => {
        debug('createSearchForCasesToConnect', 'Saving..');
        renderMode !== RenderMode.read && dispatch(draftActionCreators.requestImmediateSave());
        return await dispatch(
          whenIdle(async (_: any, getState: any) => {
            debug('createSearchForCasesToConnect', 'Done saving.');
            return api.createSearchForCasesToConnect(caseDraftId, connectionTypeId, renderMode);
          })
        );
      }
    };
  };

  return connect<any, any, any>(
    undefined,
    dispatchToProps
  )(component);
};
